import { dateToStringNoTimeZone } from '@app/shared/helpers/extensions';
import { AppointmentRequest } from './appointmentRequest.model';
import { Client } from './client.model';
import { Pet } from './pet.model';

export class SyncAppointmentRequestDataRequest {
    appointmentRequest: AppointmentRequestModel;

    constructor(appointmentRequestModel: AppointmentRequestModel) {
        this.appointmentRequest = appointmentRequestModel;
    }

    public static convertLocalStorageApptRequestToSyncApptRequestDataRequest(
        localStorageApptRequest: AppointmentRequest,
        daySmartAccountID: string
    ): SyncAppointmentRequestDataRequest {
        const lastModifiedDateTime = new Date();
        const tempStartDateTime = new Date(localStorageApptRequest.datetime);
        const startDateTime = dateToStringNoTimeZone(tempStartDateTime);
        const endDateTime = dateToStringNoTimeZone(
            new Date(tempStartDateTime.getTime() + localStorageApptRequest.service[0].duration * 60000)
        );
        const resourceIDList = localStorageApptRequest.service[0].resourceIDList;
        let resourceID;
        if (resourceIDList && resourceIDList.length) {
            resourceID = resourceIDList[0];
        }

        const appointmentRequestItem = new AppointmentRequestItem(
            localStorageApptRequest.service[0].id,
            localStorageApptRequest.employee[0].id,
            startDateTime,
            endDateTime,
            resourceID
        );
        const appointmentRequestItemList: AppointmentRequestItem[] = [];
        appointmentRequestItemList.push(appointmentRequestItem);
        let client;
        if (localStorageApptRequest.petInfo !== undefined) {
            const pet = new PetModel(localStorageApptRequest.petInfo, lastModifiedDateTime, daySmartAccountID);
            client = new ClientModel(localStorageApptRequest.client, lastModifiedDateTime, daySmartAccountID, pet);
        } else {
            client = new ClientModel(localStorageApptRequest.client, lastModifiedDateTime, daySmartAccountID);
        }

        const appointmentRequestModel = new AppointmentRequestModel(
            daySmartAccountID,
            client,
            startDateTime,
            endDateTime,
            AppointmentRequestStatuses.Pending,
            lastModifiedDateTime,
            appointmentRequestItemList,
            AppointmentRequestSources.Internal
        );

        const syncAppointmentRequestDataRequest = new SyncAppointmentRequestDataRequest(appointmentRequestModel);
        return syncAppointmentRequestDataRequest;
    }
}
export class AppointmentRequestModel {
    public id?: string;
    public daySmartAccountID: string;
    public client?: ClientModel;
    public startDateTime: string;
    public endDateTime: string;
    public status: AppointmentRequestStatuses;
    public lastModifiedDateTime: Date;
    public itemList: AppointmentRequestItem[];
    public appointmentSource?: AppointmentRequestSources;

    constructor(
        daySmartAccountID: string,
        client: ClientModel,
        startDateTime: string,
        endDateTime: string,
        status: AppointmentRequestStatuses,
        lastModifiedDateTime: Date,
        itemList: AppointmentRequestItem[],
        appointmentSource: AppointmentRequestSources,
        id?: string
    ) {
        this.id = id;
        this.daySmartAccountID = daySmartAccountID;
        this.client = client;
        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
        this.status = status;
        this.lastModifiedDateTime = lastModifiedDateTime;
        this.itemList = itemList;
        this.appointmentSource = appointmentSource;
    }
}
class ClientModel {
    public id?: string;
    public firstName: string;
    public lastName: string;
    public cell: string;
    public email: string;
    public onlineID?: string;
    public lastModifiedDateTime: Date;
    public daySmartAccountID?: string;
    public pet?: PetModel;
    public enableEmailMarketing: boolean;
    public enableTextMarketing: boolean;

    constructor(client: Client, lastModifiedDateTime: Date, daySmartAccountID: string, pet?: PetModel) {
        this.firstName = client.firstName;
        this.lastName = client.lastName;
        this.cell = client.phoneNumber;
        this.email = client.email;
        this.lastModifiedDateTime = lastModifiedDateTime;
        this.daySmartAccountID = daySmartAccountID;
        this.pet = pet;
        this.enableEmailMarketing = client.enableEmailMarketing;
        this.enableTextMarketing = client.enableTextMarketing;
    }
}
export class PetModel {
    public id?: string;
    public name: string;
    public type: PetType;
    public breed?: PetBreed;
    public weight: string;
    public clientID?: string;
    public daySmartAccountID?: string;
    public lastModifiedDateTime?: Date;

    constructor(pet: Pet, lastModifiedDateTime: Date, daySmartAccountID: string) {
        this.name = pet.name;
        this.type = new PetType(pet.petType.id, pet.petType.name);
        if (pet.petBreed) {
            this.breed = new PetBreed(pet.petBreed.id, pet.petBreed.name, pet.petBreed.typeID);
        }
        this.weight = pet.weight;
        this.lastModifiedDateTime = lastModifiedDateTime;
        this.daySmartAccountID = daySmartAccountID;
    }
}
export class PetType {
    public id: string;
    public name: string;
    public daySmartAccountID?: string;
    public lastModifiedDateTime?: string;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }
}

export class PetBreed {
    public id: string;
    public name: string;
    public typeID: string;
    public daySmartAccountID?: string;
    public lastModifiedDateTime?: string;

    constructor(id: string, name: string, typeID: string) {
        this.id = id;
        this.name = name;
        this.typeID = typeID;
    }
}
export class AppointmentRequestItem {
    public id?: string;
    public appointmentRequestID?: string;
    public serviceID: string;
    public employeeID: string;
    public resourceID?: string;
    public startDateTime: string;
    public endDateTime: string;

    constructor(
        serviceID: string,
        employeeID: string,
        startDateTime: string,
        endDateTime: string,
        resourceID?: string,
        id?: string,
        appointmentRequestID?: string
    ) {
        this.id = id;
        this.appointmentRequestID = appointmentRequestID;
        this.serviceID = serviceID;
        this.employeeID = employeeID;
        this.resourceID = resourceID;
        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
    }
}
export enum AppointmentRequestSources {
    GoodFriend = 'goodfriend',
    Internal = 'internal',
}

export enum AppointmentRequestStatuses {
    Accepted = 'accepted',
    Pending = 'pending',
    Rejected = 'rejected',
    Closed = 'closed',
    Canceled = 'canceled',
    Voided = 'voided',
    NoShow = 'no-show',
    CheckedIn = 'checked-in',
}

export class SyncAppointmentRequestDataResponse {
    newValue?: AppointmentRequestModel;
    skipped?: boolean;
    oldValue?: AppointmentRequestModel;
}
